import React, { Component } from 'react';
import { Redirect } from 'react-router'
import { inject, observer } from 'mobx-react';
import { get, post } from 'axios';
import queryString from 'query-string';
import {
  withRouter
} from "react-router-dom";

@inject('userStore')
@withRouter
class Oauth extends Component {
    constructor(props){
      super(props);
      this.state = {
        redirect:false
      }
    }

    componentDidMount(){
      const values = queryString.parse(this.props.location.search)
      post('v2/oauth', {
              code: values.code
          }, {
              auth: {username: this.props.userStore.token}
          }).then((res) => {
          alert(res.data.message);
          if (res.data.errors === 0){
            this.setState({
              redirect:true
            })
          }
      }).catch((error) => {
        console.log(error);
        return error;
      });
    }

    render(){
      if (this.state.redirect === true) {
        return <Redirect to='/settings' />
      }
      return (
        <div className="container">Stripe has been configured</div>
      )
    }
}
export default Oauth;



// WEBPACK FOOTER //
// ./src/components/business/Oauth.js